/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Creators as OrderActions } from "../../store/ducks/order";
import { Content, PickupTimeContainer, DateParagraph, HourParagraph } from './styles';
import { getFriendlyDateForDeliveryType } from '../../util/friendlyDate';
import { DeliveryType } from '../../util/deliveryType';
import ModalLayout from '../ModalLayout';

function ShowOpeningHours() {
  const dispatch = useDispatch();
  const { showOpeningHours, deliveryStoreData, checkoutData, loading } = useSelector(state => state.order);
  const [expectedDate, setExpectedDate] = useState('');
  const [expectedTimeInterval, setExpectedTimeInterval] = useState('');

  useEffect(() => {
    if (deliveryStoreData) {
      const timeParam = `${deliveryStoreData.lojaHorario.data_disponibilidade} ${deliveryStoreData.lojaHorario.hora_inicio}-${deliveryStoreData.lojaHorario.hora_fim}`
      const timeToStoreOpen = getFriendlyDateForDeliveryType(timeParam, DeliveryType.RETIRAR_NA_LOJA, checkoutData.tempo_para_retirada);
      setExpectedDate(timeToStoreOpen.friendlyDay);
      setExpectedTimeInterval(`${deliveryStoreData.lojaHorario.hora_inicio.slice(0, -3)} até ${deliveryStoreData.lojaHorario.hora_fim.slice(0, -3)}`);
    }
  }, [deliveryStoreData]);

  function finishOrder() {
    dispatch(OrderActions.orderRequest({ ...checkoutData }, true));
  }

  function closeModal() {
    dispatch(OrderActions.hideOpeningHoursModal());
  }


  useEffect(() => {
    return () => {
      dispatch(OrderActions.hideOpeningHoursModal());
    }
  }, [dispatch])

  return (
    <ModalLayout title={"Já estamos fechados"} showModal={showOpeningHours}
      buttonLeft={{
        text: loading ? "Confirmando compra" : "Confirmar compra", action: () => {
          finishOrder();
        }
      }}
      buttonRight={{
        text: "Não, obrigado", action: () => {
          closeModal();
        }
      }}>
      <Content>
        <p>
          Mas não se preocupe! Você poderá retirar seu pedido, conforme nosso próximo horário de funcionamento informado na tabela abaixo:
        </p>
        <PickupTimeContainer>
          <h3>Horários para retirada:</h3>

          {deliveryStoreData && (
            <div>
              <DateParagraph>{expectedDate}</DateParagraph>
              <HourParagraph>{expectedTimeInterval}</HourParagraph>
            </div>
          )}
        </PickupTimeContainer>
      </Content>
    </ModalLayout>
  );
}

export default ShowOpeningHours;
